import { Link } from 'react-router-dom';
import styles from './Legal.module.css';

export function Terms() {
  return (
    <div className={styles.page}>
      <nav className={styles.nav}>
        <Link to="/" className={styles.logo}>
          <span className={styles.logoAccent}>E</span>bombo
        </Link>
        <Link to="/" className={styles.backLink}>
          Back to Home
        </Link>
      </nav>

      <div className={styles.container}>
        <h1 className={styles.title}>Terms of Service</h1>
        <p className={styles.lastUpdated}>Last updated: March 27, 2026</p>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>1. Acceptance of Terms</h2>
          <p className={styles.text}>
            By accessing or using the Ebombo platform ("Service"), you agree to be bound by these
            Terms of Service. If you do not agree, you may not use the Service.
          </p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>2. Description of Service</h2>
          <p className={styles.text}>
            Ebombo is a B2B SaaS platform for corporate event management companies. The Service
            includes provider database management, AI-powered quotation generation, event
            presentation creation, and deal tracking tools.
          </p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>3. User Accounts</h2>
          <ul className={styles.list}>
            <li>You must be invited by an administrator to create an account</li>
            <li>You are responsible for maintaining the security of your account credentials</li>
            <li>You must provide accurate and complete information</li>
            <li>You may not share your account with others</li>
            <li>We reserve the right to suspend or deactivate accounts that violate these terms</li>
          </ul>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>4. Acceptable Use</h2>
          <p className={styles.text}>You agree not to:</p>
          <ul className={styles.list}>
            <li>Use the Service for any unlawful purpose</li>
            <li>Attempt to gain unauthorized access to the Service or its systems</li>
            <li>Interfere with or disrupt the Service</li>
            <li>Upload malicious code or content</li>
            <li>Scrape, crawl, or extract data from the Service without authorization</li>
            <li>Resell or redistribute the Service without permission</li>
          </ul>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>5. AI-Generated Content</h2>
          <p className={styles.text}>
            The Service uses artificial intelligence to generate quotations, analyze documents, and
            create presentations. AI-generated content is provided as a tool and should be reviewed
            by users before use. Ebombo does not guarantee the accuracy of AI-generated prices,
            recommendations, or content.
          </p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>6. Provider Data</h2>
          <p className={styles.text}>
            Provider information stored in the platform is owned by the organization that created
            it. Users are responsible for ensuring the accuracy of provider data and obtaining
            necessary consents before storing personal information of third parties.
          </p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>7. Intellectual Property</h2>
          <p className={styles.text}>
            The Service and its original content, features, and functionality are owned by Ebombo
            Technologies. Content you create using the Service (quotations, presentations, etc.)
            belongs to you and your organization.
          </p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>8. Limitation of Liability</h2>
          <p className={styles.text}>
            Ebombo shall not be liable for any indirect, incidental, special, or consequential
            damages arising from your use of the Service. Our total liability shall not exceed the
            amount paid by you in the twelve months preceding the claim.
          </p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>9. Service Availability</h2>
          <p className={styles.text}>
            We strive to maintain high availability but do not guarantee uninterrupted access to the
            Service. We may perform maintenance or updates that temporarily affect availability, and
            will provide reasonable notice when possible.
          </p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>10. Termination</h2>
          <p className={styles.text}>
            We may terminate or suspend your access to the Service at our discretion, with or
            without cause. Upon termination, your right to use the Service ceases immediately. Data
            export will be available for 30 days after termination.
          </p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>11. Changes to Terms</h2>
          <p className={styles.text}>
            We reserve the right to modify these terms at any time. We will notify users of
            significant changes via email or in-app notification. Continued use of the Service after
            changes constitutes acceptance of the new terms.
          </p>
        </div>

        <div className={`${styles.section} ${styles.contact}`}>
          <h2 className={styles.sectionTitle}>Contact Us</h2>
          <p className={styles.text}>
            For questions about these terms, contact us at{' '}
            <a href="mailto:tech@ebombo.com">tech@ebombo.com</a>.
          </p>
        </div>
      </div>
    </div>
  );
}
